export default __webpack_public_path__ + "static/media/_DSC0734.a8f32f27.JPG";